import { Box, Circle, forwardRef } from '@chakra-ui/react';

import Text from 'components/_core/Text';

import { useStyles } from '../../context';

interface StepProps {
  isLast?: boolean; // provided by <TimelineContextProvider />
}

const Step = forwardRef<StepProps, 'div'>(
  ({ children, isLast = false }, ref) => {
    const styles = useStyles();

    return (
      <Box
        __css={styles.step}
        paddingBottom={isLast ? 'space-0' : 'space-24'}
        ref={ref}
      >
        <Circle
          __css={styles.connector}
          {...(isLast ? { _after: { display: 'none' } } : {})}
        />

        <Box __css={styles.content}>
          <Text>{children}</Text>
        </Box>
      </Box>
    );
  },
);

export default Step;
